<template>
  <div class="fullHeight">
    <MypageSideMenu v-if="mobileAppHidden === false" :memberDropClose="true"/>
    <Card
        :page_title="page_title"
        iconclass="icon-icon-reserve mypage-title-icon"
      >
      <h5 class="font-weight-bold text-center mb-4">予約詳細</h5>
      <div v-if="mobileAppDataDisplayFlag" class="w-100">
        <twoColumnTable :cellData="reserve"/>
        <!-- ↓リクエスト予約時は表示しない -->
        <template v-if="reserveInfo.reserve_situation != 1">
            <table class="table table-striped mypage-reserve-table" v-for="(data, index) of groupMemberInfo" :key="data.id">
            <thead>
                <tr>
                <th class="cell-number-contents">{{ index + 1 }}組目</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="d of data" :key="d.id" class="trFlex">
                    <template v-if="d.arrayType === 'detailPlayStyle'">
                        <td class="font-weight-bold align-middle">プレースタイル</td>
                        <td>
                            <Icon :iconFlg="d.value" :dispType="d.arrayType" class="sp_play_style"/>
                        </td>
                    </template>
                    <template v-else>
                        <td class="font-weight-bold">{{d.name}}</td>
                        <td v-if="Array.isArray(d.value)" class="text-right text-sm-left">
                            <p v-for="i of d.value" :key="i.id">{{ i }}</p>
                        </td>
                        <td v-else class="text-right text-sm-left">{{ d.value }}</td>
                    </template>
                </tr>
            </tbody>
            </table>
        </template>
      </div>
      <div v-else class="w-100 text-center mb-2">{{ mobileAppDisplayText }}</div>
      <!-- 一覧へ戻るボタン追加 -->
      <template v-slot:listBackBtn>
        <div v-if="mobileAppHidden === false" class="row row-notMx">
            <div class="col-lg-3 ml-md-auto mr-md-auto text-center py-2">
                <button
                    type="button"
                    class="mypagebackbutton footer-btn-size"
                    @click="BackReserveList">
                一覧へ戻る</button>
            </div>
        </div>
      </template>
    </Card>
    <MypageMenuFooter v-if="mobileAppHidden === false" />
  </div>
</template>

<script>
import MypageSideMenu from './MypageSideMenu';
import Card from '../components/Card';
import Icon from '../components/Icon';
import twoColumnTable from '../components/twoColumnTable';
import {
    GET_RESERVE,
    GET_PLAY_TOGETHERS
} from '../../constants/mypage_reserves';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        Card,
        Icon,
        twoColumnTable
    },
    data () {
        return {
            // 前ページから受け取る
            reserveNo: '',
            page_title: '予約状況照会',
            golf_group_code: process.env.MIX_GROUP_CODE,
            // 予約情報オブジェクト
            reserveInfo: {
                reserve_situation: '',
                reserve_situation_name: '',
                play_date: '',
                play_start: '',
                cell_number: '',
                play_number: '',
                group_num: '',
                plan_name: '',
                play_style: '',
                plan_detail: '',
                golf_name: '',
                address: '',
                telephone: '',
                cancel_detail: '',
                detail: '',
                requestChoice: '',
                total_fee: 0,
                add_fee_2b_weekday: 0,
                add_fee_2b_weekend: 0,
                add_fee_3b_weekday: 0,
                add_fee_3b_weekend: 0,
            },
            reserve: [],
            groupMemberInfo: [],
            // 組の情報
            groupMember: [],
            // CodeMasterのオブジェクト
            reserve_situation_obj: {},
            iconList: [],
            // モバイルアプリデータ表示フラグ
            mobileAppDataDisplayFlag: false,
            // モバイルアプリデータ非表示テキスト
            mobileAppDisplayText: '',
            // モバイルアプリ非表示フラグ
            mobileAppHidden: false
        };
    },
    async created () {
        // モバイルアプリか判断する
        if (this.$store.state.auth.mobileAppFlag) {
            // モバイルアプリの場合、サイドメニュー、フッター、遷移ボタンを非表示にする
            this.mobileAppHidden = true;
        }
        if (this.$store.state.auth.mobileAppReserveNo) {
            this.reserveNo = this.$store.state.auth.mobileAppReserveNo;
        } else {
            if (sessionStorage.getItem('storageReserveNo')) {
                const strageData = JSON.parse(sessionStorage.getItem('storageReserveNo'));
                this.reserveNo = strageData.mypage.reserveNo;
            }
        }
        await this.getReserve();
    },
    beforeRouteLeave (to, from, next) {
        this.$store.commit("mypage/pushReserveNo", 0);
        this.$store.commit("mypage/pushPlanName", '');
        sessionStorage.removeItem('storageReserveNo');
        next();
    },
    methods: {
        /** ----------------------------------------------
         * 日付の表示を修正
         * ---------------------------------------------- */
        dateFormated (data) {
            const date = data.split('-');
            return date[0] + '年' + date[1] + '月' + date[2] + '日';
        },
        /** ----------------------------------------------
         * 時間の表示を修正
         * ---------------------------------------------- */
        timeFormated (data) {
            const time = data.split(':');
            return time[0] + '時' + time[1] + '分';
        },
        /** ----------------------------------------------
         * 2Bと3Bの表示を修正
         * ---------------------------------------------- */
        addFee2bAnd3bFormated (weekday,weekend) {
            if (weekday == 0 && weekend == 0) {
                return '割増無し';
            } else {
                return '平日:￥' + weekday.toLocaleString() + '  土日祝:￥' + weekend.toLocaleString();
            }
        },
        /** ------------------------------------------------------------------------
         * 予約情報を取得
         * mypage_reserve_flag: モバイルアプリ予約表示フラグ（1: 予約詳細 2: 予約変更）
         * ログインユーザーが予約同伴者の場合に、必要なデータを取得するか判断します。
         * 予約詳細の場合: ログインユーザーが代表者、同伴者に関わらず取得します。
         * 予約変更の場合: ログインユーザーが代表者のみ取得、同伴者は変更不可の為、非表示。
         * ----------------------------------------------------------------------- */
        getReserve () {
            this.$apollo.query({
                fetchPolicy: 'no-cache',
                query: GET_RESERVE,
                variables: {
                    reserve_no: this.reserveNo,
                    mypage_reserve_flag: 1
                }
            }).then(res => {
                const data = res.data.GetReserveDetail.Reserve;
                if (data === null) {
                    this.mobileAppDataDisplayFlag = false;
                    this.mobileAppDisplayText = '閲覧可能なデータがありません。';
                } else {
                    this.mobileAppDataDisplayFlag = true;
                    Object.keys(this.reserveInfo).forEach(el => {
                        this.$set(this.reserveInfo, el, data[el]);
                    });
                    this.groupMember.push(...data.groupInfo);
                    this.setReserve();
                    this.setGroupMemberInfo(data.display_course, data.reserve_situation);
                }
            }).catch(error => {
                this.error = error;
            })
        },
        /** ----------------------------------------------
         * メンバー情報のデータを整形
         * ---------------------------------------------- */
        setGroupMemberInfo (displayCourse, reserveSituation) {
            this.groupMemberInfo = this.groupMember.map(data => {
                const time = data.play_start.split(':');
                let play_start = time[0] + ':' + time[1];
                let play_style = {some_code: data.some_code,
                                  round_code: data.round_code,
                                  cart_code: [data.cart_code],
                                  caddie_flag: data.caddie_flag,
                                  meal_flag: data.meal_flag,
                                  accommodation_flag: data.accommodation_flag,
                                  competition_flag: data.competition_flag,
                                  through_flag: data.through_flag,
                                  lesson_flag: data.lesson_flag,
                                  reserve_type: data.reserve_type,
                                };
            // キャンセルの場合、プレーヤー名非表示
                if (reserveSituation === '4') {
                    // コース名の表示設定
                    if (displayCourse === 1) {
                        return [
                            { name: 'コース名', value: data.course_name, class: 'text-right text-sm-left'},
                            { name: 'スタート時間', value: play_start, class: 'text-right text-sm-left'},
                            { name: 'プレースタイル', value: play_style, arrayType: 'detailPlayStyle' }
                        ]
                    } else {
                        return [
                            { name: 'スタート時間', value: play_start, class: 'text-right text-sm-left'},
                            { name: 'プレースタイル', value: play_style, arrayType: 'detailPlayStyle' }
                        ]
                    }
                } else {
                    // コース名の表示設定
                    if (displayCourse === 1) {
                        return [
                            { name: 'コース名', value: data.course_name, class: 'text-right text-sm-left'},
                            { name: 'スタート時間', value: play_start, class: 'text-right text-sm-left'},
                            { name: 'プレースタイル', value: play_style, arrayType: 'detailPlayStyle' },
                            { name: 'プレーヤー名', value: data.member, class: 'text-right text-sm-left' }
                        ]
                    } else {
                        return [
                            { name: 'スタート時間', value: play_start, class: 'text-right text-sm-left'},
                            { name: 'プレースタイル', value: play_style, arrayType: 'detailPlayStyle' },
                            { name: 'プレーヤー名', value: data.member, class: 'text-right text-sm-left' }
                        ]
                    }
                }
            });
        },
        /** ----------------------------------------------
         * 予約の情報をセットする。
         * ---------------------------------------------- */
        setReserve () {
            const add3b = this.addFee2bAnd3bFormated(this.reserveInfo.add_fee_3b_weekday,this.reserveInfo.add_fee_3b_weekend);
            const add2b = this.addFee2bAnd3bFormated(this.reserveInfo.add_fee_2b_weekday,this.reserveInfo.add_fee_2b_weekend);
            this.reserve = [
                { name: '予約状況', value: this.reserveInfo.reserve_situation_name, class: 'text-right text-sm-left'},
                { name: '予約番号', value: this.reserveNo, class: 'text-right text-sm-left' },
                { name: 'ゴルフ場名', value: this.reserveInfo.golf_name, class: 'text-right text-sm-left' },
                { name: 'ゴルフ場所在地', value: this.reserveInfo.address, class: 'text-right text-sm-left' },
                { name: 'ゴルフ場電話番号', value: this.reserveInfo.telephone, class: 'text-right text-sm-left' },
                { name: 'プレー日', value: this.dateFormated(this.reserveInfo.play_date), class: 'text-right text-sm-left' },
                { name: 'スタート時間', value: this.reserveInfo.play_start ,class: 'text-right text-sm-left'},
                { name: '組数', value: `${this.reserveInfo.cell_number}組`, class: 'text-right text-sm-left' },
                { name: 'プレー人数', value: `${this.reserveInfo.play_number}人`, class: 'text-right text-sm-left' },
                { name: 'プラン名', value: this.reserveInfo.plan_name ,class: 'text-right text-sm-left' },
                { name: 'プレースタイル', value: this.reserveInfo.play_style, arrayType: 'playStyle' },
                { name: 'お一人様料金', value: '￥' + this.reserveInfo.total_fee.toLocaleString(), class: 'text-right text-sm-left' },
                { name: '3サム割増', value: add3b, class: 'text-right text-sm-left' },
                { name: '2サム割増', value: add2b, class: 'text-right text-sm-left' },
                { name: 'キャンセル規定', value: this.reserveInfo.cancel_detail, class:'text-left' },
                { name: 'プラン詳細', value: this.reserveInfo.detail, class: 'text-left' }
            ]
        },
        /** ----------------------------------------------
         * 予約状況照会一覧へ戻る
         * ---------------------------------------------- */
        BackReserveList: function (){
            this.$router.push({ path: '/mypage-reserve-list' });
        }
    }
}
</script>

<style scoped>
/* 予約詳細見出し */
h5 {
    width: 100%;
    display: block
}
@media screen and (max-width: 896px) {
    .sp_play_style {
        justify-content: flex-end;
    }
}
</style>
